import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const bannersApi = createApi({
  reducerPath: 'bannersApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: builder => ({
    fetchBanners: builder.query<any[], string>({
      query: (category: string) => ({
        url: '/banners',
        // method: 'GET',
        params: {
          category,
        },
      }),
      keepUnusedDataFor: 60 * 60,
    }),
  }),
});

export const { useFetchBannersQuery } = bannersApi;
